export interface GetDocumentsRequest {
  page?: string | number;
  fetch?: string | number;
  storageType?: string;
  countryCode: string;
  offsetDateTime?: string | number;
  offsetSeconds?: string;
  documentStatusCode?: string;
  customerCode?: string;
  productLineCode?: string;
  serviceCenterId?: string;
  orderBy?: string;
  dateFrom?: string;
  dateTo?: string;
  documentTypeCode?: string;
  groupId?: number;
  groupCode?: string;
  subGroupId?: number;
  subGroupCode?: string;
  jobsiteCode?: string;
  pointOfDeliveryCode?: string;
  managementCode?: string;
}

export interface AssignDocumentRequest {
  assignation: {
    assignedTo: {
      userAccount: string;
    };
  };
}
